import { useNavigate } from 'react-router-dom';

export default function AboutSection() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20bright%20home%20office%20corner%20with%20white%20desk%20holding%20laptop%20displaying%20organized%20digital%20spreadsheet%20interface%20with%20product%20thumbnails%2C%20small%20potted%20plant%20and%20ceramic%20mug%20nearby%2C%20warm%20natural%20light%20streaming%20through%20sheer%20curtains%2C%20calm%20organized%20productive%20atmosphere%2C%20modern%20Scandinavian%20interior%20aesthetic%2C%20editorial%20interior%20photography%2C%20no%20text%20no%20people&width=900&height=700&seq=about-spreadsheet-2026-v2&orientation=landscape"
                alt="What is Superbuy Spreadsheet - organized product discovery"
                title="Superbuy Spreadsheet product discovery workspace"
                className="w-full h-auto rounded-3xl"
              />
              <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-primary-100 rounded-2xl flex items-center justify-center">
                <i className="ri-file-list-3-line text-3xl text-primary-500"></i>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 bg-accent-100/80 text-accent-700 text-xs font-semibold rounded-full uppercase tracking-wider mb-4">
              What Is This?
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-6 leading-tight">
              What Is <span className="text-primary-500">Superbuy Spreadsheet</span>?
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-6">
              A <strong>Superbuy Spreadsheet</strong> is an organized product discovery resource that helps shoppers 
              find products from various marketplaces faster and smarter. Instead of manually searching 
              through thousands of listings, users can browse categorized spreadsheets containing 
              product links, price information, category tags, and shopping recommendations — all in one clean, organized view.
            </p>

            <div className="grid grid-cols-2 gap-3 mb-8">
              {[
                { icon: 'ri-time-line', title: 'Save Hours', desc: 'Skip endless searching' },
                { icon: 'ri-eye-line', title: 'Discover Hidden', desc: 'Find unique products' },
                { icon: 'ri-scales-line', title: 'Compare Easily', desc: 'Side by side pricing' },
                { icon: 'ri-shield-check-line', title: 'Shop Confidently', desc: 'Verified information' },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-3 p-3 rounded-xl bg-background-100">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                    <i className={`${item.icon} text-accent-600 text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-800">{item.title}</p>
                    <p className="text-xs text-foreground-500">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => navigate('/blog/superbuy-spreadsheet-guide')}
              className="inline-flex items-center gap-2 px-6 py-3 border-2 border-foreground-200 text-foreground-700 font-semibold rounded-full hover:border-primary-500 hover:text-primary-500 transition-all text-sm whitespace-nowrap cursor-pointer"
            >
              Learn More About Superbuy Spreadsheet
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}